import { Box, Typography } from '@mui/material';
import React from 'react';
import { Task } from '../../../types/Task';
import {
  tileContainerStyles,
  tileHeaderSectionStyles,
  textContainerStyles,
  tileSectionLeftStyles,
  tileSectionRightStyles,
  tileHeaderLeftStyles,
  secondaryTextStyles,
  secondaryLabelStyles,
  secondaryIconStyles,
} from '../dashboardStyles';
import TaskDuePill from '../../tasks/TaskDuePill';
import _ from 'lodash';
import { AccountCircleOutlined, EventAvailable } from '@mui/icons-material';
import { UserConfigurableModule } from '../../../types/User';
import DrawerLink from '../../common/drawers/ModuleDrawer/DrawerLink';

interface ITaskTileProps {
  task: Task;
  currentEmployeeUuid?: string;
}

export function TaskTile(props: ITaskTileProps) {
  const { task, currentEmployeeUuid } = props;
  let secondaryLink = null;
  if (task.event_uuid) {
    secondaryLink = {
      module: UserConfigurableModule.EVENTS,
      uuid: task.event_uuid,
      label: task.event_display_name,
    };
  } else if (task.account_uuid) {
    secondaryLink = {
      module: UserConfigurableModule.ACCOUNTS,
      uuid: task.account_uuid,
      label: task.account_display_name,
    };
  }

  const employeeText = task.employee_uuid === currentEmployeeUuid ? 'You' : task.employee_display_name;
  return (
    <Box key={task.uuid} sx={tileContainerStyles}>
      <Box sx={tileSectionLeftStyles}>
        <Box sx={tileHeaderSectionStyles}>
          <DrawerLink module={UserConfigurableModule.TASKS} uuid={task.uuid}>
            <Typography title={task.name} sx={tileHeaderLeftStyles}>
              {task.name}
            </Typography>
          </DrawerLink>
        </Box>
        <Box sx={textContainerStyles}>
          {secondaryLink && (
            <Box sx={secondaryTextStyles}>
              <EventAvailable sx={secondaryIconStyles} />
              <DrawerLink module={secondaryLink.module} uuid={secondaryLink.uuid}>
                <Typography sx={secondaryLabelStyles}>{secondaryLink.label}</Typography>
              </DrawerLink>
            </Box>
          )}

          {task.employee_uuid && (
            <Box sx={secondaryTextStyles}>
              <AccountCircleOutlined sx={secondaryIconStyles} />
              <DrawerLink module={UserConfigurableModule.EMPLOYEES} uuid={task.employee_uuid}>
                <Typography sx={secondaryLabelStyles}>{employeeText}</Typography>
              </DrawerLink>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={tileSectionRightStyles}>
        <TaskDuePill title={_.startCase(task.status)} task={task} />
      </Box>
    </Box>
  );
}
